import { render, staticRenderFns } from "./PolicyList.vue?vue&type=template&id=721e18b0&"
import script from "./PolicyList.vue?vue&type=script&lang=js&"
export * from "./PolicyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721e18b0')) {
      api.createRecord('721e18b0', component.options)
    } else {
      api.reload('721e18b0', component.options)
    }
    module.hot.accept("./PolicyList.vue?vue&type=template&id=721e18b0&", function () {
      api.rerender('721e18b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alerts/PolicyList.vue"
export default component.exports